export default __webpack_public_path__ + "static/media/not-found.f0216206.png";